import DynamicSlider from "./DynamicSlider";
import CustomRequestFieldComponent from "./CustomRequestFieldComponent";
import TaskDetailsTab from "../Pages/RequestDashboard/TaskDetailsTab";
import CorrActionDetailsTab from "../Pages/RequestDashboard/CorrActionDetailsTab";

export const componentRegistry: Record<string, React.ComponentType<any>> = {
  DynamicSlider,
  //CustomSlider,
//  EvaluationForm,
  TaskDetailsTab,
  CorrActionDetailsTab
  // Add more components that you trust to render dynamically
};
